import fetchCoordinatesAndRefineSearch from '@/utils/search/fetchCoordinatesAndRefineSearch'
import { mapLocationGeoToLocationType } from '@/domain/location/useCases/mapLocationGeoToLocationType'
import refineSearchState from '@/domain/search/refineSearchState'
import mapLocationNameToAlgolia from '@/utils/search/mapLocationNameToAlgolia'
import { navigateToBrowsePageWithQueryParams } from '@/domain/search/navigateToBrowsePageWithQueryParams'

const onItemSelect = async ({ item }) => {
  if (item.googlePlaceId) {
    const refinedSearchState = await fetchCoordinatesAndRefineSearch({
      googlePlaceId: item.googlePlaceId,
      locationName: item.formattedAddress,
      locationType: mapLocationGeoToLocationType(item.types),
      simpleLocationName: mapLocationNameToAlgolia(
        item.structured_formatting.main_text
      )
    })
    return navigateToBrowsePageWithQueryParams(refinedSearchState)
  }
  if (item.aroundLatLngViaIP) {
    return navigateToBrowsePageWithQueryParams(
      refineSearchState({
        configure: { aroundLatLngViaIP: true }
      })
    )
  }
  return navigateToBrowsePageWithQueryParams(
    refineSearchState({ taxonomy: item })
  )
}

export default onItemSelect
